export function sendLoginEventToGTAG(label, email, role) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: label,
    email: email,
    role: role,
  });
}
export function sendRefreshEventToGTAG(email, role) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    email: email,
    role: role,
  });
}

export function sendPWAEventToGTAG(value) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    browser_or_pwa: value,
  });
}
